<div class="container-center">
    <h1>404 Stranica nije pronađena</h1>
    <p>
        <span class="clickable home-link" [routerLink]="''">Vratite se na naslovnu stranicu</span>
    </p>
</div>